module.exports = __webpack_public_path__ + "img/favicon.eeca61ab.png";